var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { bus: _vm.busModal },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("v-spacer"),
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "BaseButton",
                {
                  attrs: { primary: "", loading: _vm.loading },
                  on: { click: _vm.enviar }
                },
                [_vm._v(" Enviar ")]
              ),
              _c("v-spacer")
            ]
          }
        }
      ])
    },
    [
      _c("Title", { attrs: { title: "Validar e-mail" } }),
      _c("div", [
        _c("p", [
          _vm._v(" Você receberá um "),
          _c("i", [_vm._v("link")]),
          _vm._v(
            " para validar o seu e-mail e começar a utilizá-lo como remetente. "
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }